import React from 'react';
import { Gift, Star, Clock, Users } from 'lucide-react';

const PROMO_BG = "https://static.prod-images.emergentagent.com/jobs/3dca5804-461a-4919-9a13-70c20d6d472a/images/12a5867e19dfe7c45f7724ce3dd335b237925c316a9fcf61044fe3528af1f762.png";

/**
 * Shareable promo image page - screenshot this for social media
 */
const PromoShareImage = () => {
    return (
        <div className="min-h-screen bg-gray-900 flex items-center justify-center p-8">
            {/* Promo Card - optimized for social sharing (1200x630 is ideal for most platforms) */}
            <div 
                className="relative w-[1200px] h-[630px] rounded-3xl overflow-hidden shadow-2xl"
                style={{
                    backgroundImage: `url(${PROMO_BG})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            >
                {/* Content Overlay */}
                <div className="absolute inset-0 flex">
                    {/* Left side - branding with better contrast */}
                    <div className="w-1/2 flex flex-col justify-center pl-16 pr-8">
                        {/* Semi-transparent backdrop for text readability */}
                        <div className="bg-gradient-to-r from-[#1D6B6B]/80 to-transparent p-8 -ml-8 rounded-r-3xl">
                            {/* Logo/Brand */}
                            <div className="mb-6">
                                <div className="text-white/90 text-lg font-medium tracking-widest mb-2">
                                    COREGULATE
                                </div>
                                <h1 className="text-5xl font-bold text-white leading-tight drop-shadow-lg">
                                    Help Shape<br />
                                    <span className="text-[#FFBB98]">the Future of</span><br />
                                    <span className="text-[#FFBB98]">ADHD Regulation</span><br />
                                    <span className="text-[#FFBB98]">& Relationships</span>
                                </h1>
                            </div>
                            
                            <p className="text-xl text-white/90 leading-relaxed max-w-md drop-shadow">
                                Join our community of ADHDers building tools that actually work for our minds.
                            </p>
                        </div>
                    </div>

                    {/* Right side - promo details */}
                    <div className="w-1/2 flex flex-col justify-center pr-16 pl-8">
                        {/* Promo Card */}
                        <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-xl max-w-sm ml-auto">
                            {/* Badge */}
                            <div className="flex items-center gap-2 mb-4">
                                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#FFBB98] to-[#E09060] flex items-center justify-center">
                                    <Gift className="w-5 h-5 text-white" />
                                </div>
                                <span className="text-[#1D6B6B] font-semibold text-lg">Community Invite</span>
                            </div>

                            {/* Code */}
                            <div className="mb-6">
                                <div className="text-sm text-gray-500 mb-2">Your exclusive code:</div>
                                <div className="bg-[#1D6B6B]/10 border-2 border-dashed border-[#1D6B6B]/40 rounded-xl p-4 text-center">
                                    <span className="font-mono text-3xl font-bold text-[#1D6B6B] tracking-widest">
                                        COREGULATER
                                    </span>
                                </div>
                            </div>

                            {/* Benefits */}
                            <div className="space-y-3 mb-6">
                                <div className="flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-full bg-[#FFBB98]/20 flex items-center justify-center">
                                        <Clock className="w-4 h-4 text-[#FFBB98]" />
                                    </div>
                                    <span className="text-gray-700 font-medium">14 days FREE premium</span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-full bg-[#1D6B6B]/10 flex items-center justify-center">
                                        <Star className="w-4 h-4 text-[#1D6B6B]" />
                                    </div>
                                    <span className="text-gray-700 font-medium">All regulation tools unlocked</span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-full bg-[#F48FB1]/20 flex items-center justify-center">
                                        <Users className="w-4 h-4 text-[#F48FB1]" />
                                    </div>
                                    <span className="text-gray-700 font-medium">Shape tools with feedback</span>
                                </div>
                            </div>

                            {/* URL */}
                            <div className="text-center pt-4 border-t border-gray-200">
                                <span className="text-[#1D6B6B] font-semibold text-lg">
                                    coregulateadhd.com/join
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PromoShareImage;
